import { createSlice } from "@reduxjs/toolkit";

const navHeightSlice = createSlice({
  name: "navHeight",
  initialState: 121,
  reducers: {
    setNavHeight: (state, action) => action.payload,
  },
});

export const { setNavHeight } = navHeightSlice.actions;

export const selectNavHeight = (state) => state.navHeight;

export default navHeightSlice.reducer;
